export default class Explanation {
  constructor() {
    this.contents = document.querySelector('._explanation');
    this.text = this.contents.querySelector('._text');
    this.more = this.contents.querySelector('._more');
    this.close = this.contents.querySelector('._close');

    let _textContent = this.text.textContent;
    if(_textContent.length > parseInt(this.text.dataset.trimming)){
      let _innerHTML = this.text.innerHTML;
      // ISSEY-1010の対応でspanタグを入れる
      this.text.innerHTML = '<span class="_full">'+_innerHTML+'</span><span class="_trimming">'+_innerHTML.replace(/<a /gi, '<span><a ').replace(/<\/a>/gi, '</a></span>')+'</span>';

      const _ch = this.text.clientHeight;
      this.contents.classList.add("close");
    }else{
      this.more.remove()
      this.close.remove()
    }

    if(document.getElementsByName("color").length>4)
    {
      this.contents.classList.add("short");
    }

    this.setup()
  }

  setup () {
    this.more.addEventListener('click', (event) => {
      this.contents.classList.remove("close");
    });
    this.close.addEventListener('click', (event) => {
      this.contents.classList.add("close");
    });
  }

}